import { render, staticRenderFns } from "./WorksMatchingList.vue?vue&type=template&id=610051ca&"
import script from "./WorksMatchingList.vue?vue&type=script&lang=js&"
export * from "./WorksMatchingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports